export default __webpack_public_path__ + "static/media/11.ab84fc82.png";